/* global axios */
import ApiClient from './ApiClient';

class LeadsAPI extends ApiClient {
  constructor() {
    super('leads', { accountScoped: true });
  }

  // params: { pipeline_id, stage_id, search, assignee_id, status }
  get(params = {}) {
    const entries = Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    );
    const query = entries.length
      ? `?${new URLSearchParams(entries).toString()}`
      : '';
    return axios.get(`${this.url}${query}`);
  }

  // Agregados por etapa (conteo + suma) para los encabezados de columna.
  stats(params = {}) {
    const entries = Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    );
    const query = entries.length
      ? `?${new URLSearchParams(entries).toString()}`
      : '';
    return axios.get(`${this.url}/stats${query}`);
  }

  // Widgets del panel superior del tablero (6 valores en 1 request).
  dashboard(params = {}) {
    const entries = Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    );
    const query = entries.length
      ? `?${new URLSearchParams(entries).toString()}`
      : '';
    return axios.get(`${this.url}/dashboard${query}`);
  }

  move(leadId, stageId, position) {
    return axios.patch(`${this.url}/${leadId}/move`, {
      stage_id: stageId,
      position,
    });
  }

  events(leadId) {
    return axios.get(`${this.url}/${leadId}/events`);
  }

  // Export CSV (blob). Sin id = leads filtrados del pipeline; con id = un lead.
  exportLeads(params = {}) {
    const entries = Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    );
    const query = entries.length
      ? `?${new URLSearchParams(entries).toString()}`
      : '';
    return axios.get(`${this.url}/export${query}`, { responseType: 'blob' });
  }

  exportLead(leadId) {
    return axios.get(`${this.url}/${leadId}/export`, { responseType: 'blob' });
  }

  // Restaurar / borrar definitivamente un lead archivado (solo admin).
  restore(leadId) {
    return axios.post(`${this.url}/${leadId}/restore`);
  }

  destroyPermanently(leadId) {
    return axios.delete(`${this.url}/${leadId}/destroy_permanently`);
  }

  // Aviso de duplicado: dado teléfono/email, el dueño del lead existente (+ desde cuándo).
  duplicateOwner(params = {}) {
    const entries = Object.entries(params).filter(
      ([, value]) => value !== '' && value !== null && value !== undefined
    );
    const query = entries.length
      ? `?${new URLSearchParams(entries).toString()}`
      : '';
    return axios.get(`${this.url}/duplicate_owner${query}`);
  }
}

export default new LeadsAPI();
